import React from 'react';

import ClickableIcon from '~components/ClickableIcon';
import { faCheck, faXmark } from '~components/icon';

interface ComponentProps {
  isEditing: boolean;
  rowId: string | number;
  onSave?: () => void;
  onCancel?: (row: any) => void;
}

const TableEditActions: React.FC<ComponentProps> = ({ isEditing, rowId, onSave, onCancel }) => {
  if (isEditing) {
    return (
      <div className="d-flex justify-content-end">
        <ClickableIcon
          id={`${rowId}-save`}
          icon={faCheck}
          className="me-2"
          size="small"
          color="success"
          onClick={onSave}
          toolTip="Save"
        />
        <ClickableIcon
          id={`${rowId}-cancel`}
          icon={faXmark}
          className="me-2"
          size="small"
          color="danger"
          onClick={onCancel}
          toolTip="Cancel"
        />
      </div>
    );
  }

  return null;
};

export default TableEditActions;
